<template>
  <v-container grid-list-md fluid >
  <v-layout row wrap>

    <v-snackbar
        v-model="mainSnackbar"
    >
        {{mainSnackbarText}}
        <v-btn
            color="pink"
            flat
            @click="closeMainSnackBar"
        >
            Close
        </v-btn>                            
    </v-snackbar>  

    <!--
    <v-flex xs12 pa-0>
    <v-tabs
      pa-0
      v-model="active"
      color="cyan"
      dark
      slider-color="yellow"
    >
      <v-tab
        v-for="y in endowmentFundraiserPaymentsGroupedByYearLine.yearly"
        :key="y.year"
        ripple
      >
        {{ y.year }}
      </v-tab>
      <v-tab-item
        v-for="y in endowmentFundraiserPaymentsGroupedByYearLine.yearly"
        :key="y.year"
      >
        <v-card flat :height="200 + (y.payments.length * 55)">
          <v-card-text><span class="title"> {{y.year}} Endowment Campaign</span><br/><span class="subheading">Total Contributions - By Line </span> <div class="hello" v-bind:style="'width:100%;height:' + 145 + (y.payments.length * 50) + 'px;'"  v-bind:id="'chartdiv-' + y.year"></div></v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>

    </v-flex>
    -->
    <v-flex xs12 pa-1>
        <v-card>
            <v-card-title>
                <span class="title"><v-icon>{{fundraiserProperties.fundraisericon}}</v-icon> {{fundraiserProperties.fundraisertitle}} </span>
                <span v-if="fundraiserid ==='endowment'" class="caption">&nbsp; (est. 2014)</span>
            </v-card-title>
            <v-card-text v-if="fundraiserProperties.showTotals"><v-icon>show_chart</v-icon>
                <span class="title font-weight-black green--text">${{fundraiserPaymentsGroupedByYearLine.grandtotal}}</span> 
                <span class="body primary--text"> raised so far!</span>
            </v-card-text>
        </v-card>
    </v-flex>

        <v-flex xs12 pa-1>
        <v-card>
            <v-card-title>
                <span class="title">Contribute Now</span>
                
            </v-card-title>
            <v-card-text>
                <template v-for="c in fundraiserCampaignsActive">
                    <div v-bind:key="'cname' + c.campaignid" class="font-weight-bold">{{c.campaignname}}</div>
                    <div v-bind:key="'cdates' + c.campaignid" class="grey--text"><em>Active from {{c.datestart}} to {{c.dateend}}</em></div>
                    <div v-bind:key="'cdesc' + c.campaignid" style="margin-left:8px;">{{c.description}}</div>

                    <div v-bind:key="'cpaypal' + c.campaignid" class="pa-0">
                        <v-btn
                        v-bind:key="'cpaypalbtn' + c.campaignid"
                        color="primary"
                        dark
                        @click="openDialogPaypal(c)"
                        >
                        <font-awesome-icon icon="credit-card" />
                        &nbsp; Make a Payment
                        </v-btn>
                        <br/><br/>
                    </div>
                    <v-divider v-bind:key="'cdivider' + c.campaignid"></v-divider>
                </template>
                
                <div class="subheading font-weight-bold">Here's what your Line Members contributed:</div>
                <div class="subheading">{{memberline.linename}}</div>
                <v-layout row wrap v-if="fundraiserLinePayments && fundraiserLinePayments.length>0">
                    <template v-for="linepayment in fundraiserLinePayments">
                    <v-flex  xs6 pa-0 v-bind:key="'vflex1-' + linepayment.lineid + linepayment.member + linepayment.paymentdate" >
                    <v-list two-line>
                        <v-list-tile>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                        <v-icon>person</v-icon>
                                        {{linepayment.member.toUpperCase()}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                        <span class="caption">${{linepayment.paymentamount}} - {{linepayment.paymentdate}}</span>
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-divider></v-divider>
                    </v-list>
                    </v-flex>
                    </template>              
                </v-layout>
                <v-layout v-else row wrap >
                    <v-flex xs12 pa-0 >
                        <span class="font-weight-bold red--text">Your line has made NO contributions.</span>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-flex>

    <v-flex xs12 pa-0 v-if="fundraiserProperties.showTotals">
        <v-card v-if="lineChartData && lineChartData.length>0">
            <v-card-title>
                <span class="title">Contribution Trend Analysis</span>
            </v-card-title>
            <v-card-text>
            <v-flex xs12 pa-0>
            <template v-if="lineChartData">
                <line-chart
                :data="lineChartData"
                :options="{responsive: true, maintainAspectRatio: false}"                
                >
                </line-chart>
            </template>
            </v-flex>
            </v-card-text>
        </v-card>
    </v-flex>
    <v-flex xs12 raised pa-1 v-if="fundraiserProperties.showTotals">        
    <v-tabs
      v-if="chartsData && chartsData.length>0"
      pa-0
      v-model="active"
      color="primary"
      dark
      slider-color="yellow"
    >
      <v-tab
        v-for="chartdata in chartsData"
        :key="chartdata.datasets[0].label"
        ripple
      >
        {{ chartdata.datasets[0].label.split('|')[0].trim() }}
      </v-tab>
      <v-tab-item
        v-for="chartdata in chartsData"
        :key="chartdata.datasets[0].label"
      >
        <v-card :height="400 + (chartdata.datasets[0].data.length * 45)">
          <v-card-title>
            <span class="title">Line Contributions ({{chartdata.datasets[0].label.split('|')[0].trim() }})</span>
          </v-card-title>
          <v-card-text>
              <span class="subheading"> {{fundraiseridNormalCase}}: {{chartdata.datasets[0].label.split('|')[0].trim() }} Contributions = <span class="font-weight-bold">{{chartdata.datasets[0].label.split('|')[1].trim() }}</span></span><br/>
              <span class="caption">Total Contributions - By Line </span> 
                <bar-chart
                :data="chartdata"
                :options="{responsive: false, maintainAspectRatio: false}"
                
                :height="140 + (chartdata.datasets[0].data.length * 42)"
                >
                </bar-chart>              
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>    
    </v-flex>
    <v-flex xs12 raised pa-1 v-if="fundraiserPaymentsSorted && fundraiserPaymentsSorted.length>0">   
        <v-card>
            <v-card-title>
                <div class="subheading font-weight-bold">Contributors</div>
            </v-card-title>
            <v-card-text>
                <v-layout row wrap>
                <template v-for="(p, indx) in fundraiserPaymentsSorted">
                <v-flex class="caption pa-1 pt-4 " xs6 :key="`vflexfpmnt-${indx}`"> 
                    <v-layout column>
                    <v-flex grey lighten-4 pa-1> 
                    <span class="primary--text font-weight-bold">${{p.paymentamount}}&nbsp; &nbsp;</span> <b>{{p.member.toUpperCase().replace('_',', ')}}</b>
                    </v-flex>   
                    <v-flex grey lighten-4 pa-1>
                    {{p.lineid}} 
                    </v-flex>                                         
                    <v-flex grey lighten-4 pa-1>
                    {{p.paymentdate.split(" ")[0]}} 
                    </v-flex>

                    </v-layout>
                </v-flex>
                <v-divider :key="`vdvdrfpmnt-${indx}`"></v-divider>
                </template>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-flex>



        <v-dialog
            v-model="dialogPaypal"            
            pa-2
            v-show="dialogPaypal"
            >

            <v-card >
                <v-toolbar dark color="primary">
                    <v-toolbar-side-icon @click="closeDialogPaypal">
                    <v-icon>close</v-icon>
                                                    
                    </v-toolbar-side-icon>
                    <v-toolbar-title>Make a Payment</v-toolbar-title>
                    <v-spacer></v-spacer>

                </v-toolbar>                        


                <v-card-text>
                    <div class="title font-weight-bold">{{fundraiseridNormalCase}} Fund Campaign</div>
                    <div class="subheading font-weight-bold pa-2"><v-icon>monetization_on</v-icon> Contribute Now!</div>
                    <br/>
                    <v-select
                    v-if="paypalCampaign"
                    v-model="paypalamountselected"
                    :items="paypalCampaign.paypal.paypalamounts"
                    label="Select Contribution Amount"
                    >
                    
                        <template  slot="item" slot-scope="data">                
                            <span v-if="data.item" class="caption" style="width:200px;">${{ data.item.amount }} - {{ data.item.item }} </span>
                        </template>    

                        <template  slot="selection" slot-scope="data">                
                            {{ data.item.amount }}
                        </template>                       
                    
                    </v-select>                    
                     <pay-pal-checkout
                     v-if="dialogPaypal && paypalamountselected"
                     :env="paypalenv"
                    :amount="paypalamountselected.amount"
                    currency="USD"
                    :client="paypalCampaign.paypal.paypalcredentials"
                    :items="paypalItems"
                    :notify-url="paypalnotifyurl"
                    >
                    </pay-pal-checkout>
                    <br/><br/>
                    <div v-if="dialogPaypal && paypalamountselected">You selected <em>{{paypalamountselected.item}}</em>. Click the Paypal button to contribute <b>${{paypalamountselected.amount}}</b> now.</div>

                    <div v-if="dialogPaypal && paypalamountselected" style="font-size:5px;color:grey;"><br/>Paypal Env:{{paypalenv}}<br/>Callback Url: {{paypalnotifyurl}}<br/>Client ID: {{paypalCampaign.paypal.paypalcredentials}} </div>
                </v-card-text>

            </v-card>


            <v-snackbar
                v-model="mainSnackbar"
            >
                {{mainSnackbarText}}
                <v-btn
                    color="pink"
                    flat
                    @click="closeMainSnackBar"
                >
                    Close
                </v-btn>                            
            </v-snackbar>  
        </v-dialog>


  </v-layout>
  </v-container>
</template>


<script>
  import firebase from 'firebase'
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_material from "@amcharts/amcharts4/themes/material";

am4core.useTheme(am4themes_animated);
import moment from 'moment'

const DATEFORMAT_CAMPAIGNS = "YYYY-MM-DD"


import BarChart from './components/BarChart'
import LineChart from './components/LineChart'
import PayPalCheckout from 'vue-paypal-checkout'

  export default {
      components: {BarChart, LineChart, PayPalCheckout},
    data () {
        return {        
            active: null,    
            dialogPaypal: false,
            snackbar: false,
            snackbarText: null,
            mainSnackbar: false,
            mainSnackbarText: null,            
            messagetext: null,
            fundraiserid: null,
            chartsData: null,
            lineChartData: null,
            lineChartDataOptions: null,
            paypalCampaign: null,
            /*
            paypalcredentials: {
                sandbox: 'AXbxQHZSheVLrN1M8PBXrpAGnUwmn-NkPcvvCHa6KF8_wStEYvD0N0gtPfM2j6o--h5VZI8pzim5fxfG',
                production: '<production client id>'
            },
            */
            paypalItems:[{
                name: '',
                description: '',
                quantity: '1',
                price: '50',
                currency: 'USD'
                }
            ],
            paypalamountselected: null,
            paypalamounts:['25.00','50.00','100.00','150.00','200.00','250.00','300.00']         
           
        }
    },
    created () {

        //TODO: variablize the entire page to be used for all post types based this.$route.path
        //console.log('.............route.path = ' , this.$route.path.substring(1))
        this.fundraiserid = this.$route.path.substring(1)
       
    },
    
  mounted() {
      //this.showYearCharts()
      this.fundraiserid = this.$route.path.substring(1)
      this.populateChartsData()
  },

  beforeDestroy() {

  },    
    computed: {
        paypalnotifyurl(){
            var rtn = "https://us-central1-zzques-staging.cloudfunctions.net/ipnHandler"
            if(process.env.NODE_ENV==='development' || process.env.NODE_ENV==='staging'){
                rtn = "https://us-central1-zzques-staging.cloudfunctions.net/ipnHandler"
            }else{
                rtn = "https://us-central1-zzques-2e9f8.cloudfunctions.net/ipnHandler"  
            }
            return rtn
        },
        paypalenv(){
            var rtn = 'sandbox' 
            if(process.env.NODE_ENV==='development' || process.env.NODE_ENV==='staging'){
                rtn = 'sandbox'
            }else{
                rtn ='production'
            }
            return rtn
        },        
      myColor () {
         return this.$store.getters.myColor
      },         
      user () {
        return this.$store.getters.user
      },
      member () {
        return this.$store.getters.member
      },
      colorMain () {
          return this.$store.getters.colorMain
      },
      allMembers () {
          return this.$store.getters.allMembers
      },
      sortedLinesAndMembers () {
          return this.$store.getters.sortedLinesAndMembers
      },
      memberline () {
          return this.$store.getters.memberLine
      },
      fundraiseridNormalCase(){
          return this.fundraiserid.substring(0,1).toUpperCase() + this.fundraiserid.substring(1)
      },
      fundraiserProperties (){
          return this.$store.getters.listFundraiserTypes[this.fundraiserid]
      },
      fundraiserCampaignsActive (){
          var campaigns = this.$store.getters.listFundraiserTypes[this.fundraiserid].campaigns
          if(campaigns && campaigns.length>0){
              campaigns = campaigns.filter(c=>{
                  var momStart = moment(c.datestart, DATEFORMAT_CAMPAIGNS)
                  var momEnd = moment(c.dateend, DATEFORMAT_CAMPAIGNS)
                  var rightNow = moment()
                  console.log('moment()',rightNow)
                  console.log('momStart',momStart)
                  console.log('momEnd',momEnd)
                  console.log('rightNow.isBetween(momStart,momEnd)',rightNow.isBetween(momStart,momEnd))
                  


                  if(rightNow.isBetween(momStart,momEnd)){
                  //if(rightNow.isAfter(momStart, 'day') && rightNow.isBefore(momEnd, 'day')){
                      console.log('return true')
                      return true
                  }else{
                      console.log('return false')
                      return false
                  }
              })
          }
          return campaigns
      },      
      fundraiserPayments () {
            
            return this.$store.getters.fundraiserPayments[this.fundraiserid]
      },
      fundraiserPaymentsSorted(){

            if(this.$store.getters.fundraiserPayments[this.fundraiserid]){
                var s = this.$store.getters.fundraiserPayments[this.fundraiserid].sort((a,b)=>{if(b.member>a.member){return -1}else{return 1}})
                return s
            }else{
                return null
            }            
            
      },
      fundraiserPaymentsGroupedByYearLine () {
            
            return this.$store.getters.fundraiserPaymentsGroupedByYearLine[this.fundraiserid]
      },        
      fundraiserMemberPayments () {
            
            return this.$store.getters.fundraiserMemberPayments[this.fundraiserid]            
      },
      fundraiserLinePayments () {
            
            return this.$store.getters.fundraiserLinePayments[this.fundraiserid]
            
      },
      fundraiserPaymentsGroupedByYearMonth() {
          return this.$store.getters.fundraiserPaymentsGroupedByYearMonth[this.fundraiserid]
      }       
              
    },
    watch: {
        paypalamountselected (value){
            this.updatePaypalButton()
        }
    },
    methods: {
        updatePaypalButton: function (){
            var description = new Object ()
            description.member = this.$store.getters.member.member
            description.userid = this.$store.getters.member.userid
            description.lineid = this.$store.getters.member.lineid
            description.firstname = this.$store.getters.member.firstname
            description.lastname = this.$store.getters.member.lastname
            description.org = this.$store.getters.member.org
            description.chapter = this.$store.getters.member.chapter
            description.fundraiser = this.fundraiserid
            description.fundraisername = this.fundraiserProperties.fundraisertitle
            if(this.paypalamountselected){
                description.paymentamount= this.paypalamountselected.amount
                description.item = this.paypalamountselected.item
            }



            var item = new Object()
            item.name = this.fundraiserid.toUpperCase() + " CAMPAIGN"
            item.description = JSON.stringify(description)
            if(this.paypalamountselected){
                item.price = this.paypalamountselected.amount
            }
            item.quantity="1"
            item.currency ='USD'

            this.paypalItems = new Array ()
            this.paypalItems.push(item)
            //console.log('called updatePaypalButton...this.paypalItems', this.paypalItems)
        },
        paymentCompleted: function (data) {
            console.log('paymentCompleted', data)
            this.mainSnackbarText = "Payment successfully sumitted"
            this.openSnackBar()            
            //this.closeDialogPaypal()
        },
        paymentAuthorized: function (data) {
            console.log('paymentAuthorized', data)
            this.mainSnackbarText = "Payment successfully authorized"
            this.openSnackBar()   
            //this.closeDialogPaypal()
         
        },        
        openDialogPaypal: function (campaign){
            //console.log('openDialogPaypal for campaign', campaign)
            this.paypalCampaign= campaign
            this.dialogPaypal = true    
            this.updatePaypalButton()   
        },
        closeDialogPaypal: function (){
            this.dialogPaypal = false
            this.paypalCampaign = null
        },        
        openSnackBar: function (){
            this.snackbar = true
        },
        closeSnackBar: function (){
            this.snackbar = false
            this.snackbarText = null
        },
        openMainSnackBar: function (){
            this.mainSnackbar = true
        },
        closeMainSnackBar: function (){
            this.mainSnackbar = false
            this.mainSnackbarText = null
        },
        populateChartsData: function (){
           var color = '#9842f4'
           const chartcolors=['#00938e','#af9800','#006625','#610096','#0061ff','#96000c']
           var arrChartsData = new Array() 
           var i = -1
           //var v = this.$store.getters[this.fundraiserid + 'FundraiserPaymentsGroupedByYearLine'].yearly
           var v = this.fundraiserPaymentsGroupedByYearLine.yearly
           v.forEach(function(y) {
                i++
                var tmpObjChartData = new Object()
                tmpObjChartData.labels = new Array()
                tmpObjChartData.datasets = new Array()
                var tmpDataset  = new Object()     
                tmpDataset.data = new Array()          
                var titleyear = y.year  + ' | $' + y.total.toFixed(2)
                tmpDataset.label = titleyear
                tmpDataset.backgroundColor = chartcolors[i]
                y.payments.forEach(function(pymt){
                    tmpObjChartData.labels.push(pymt.line)
                    tmpDataset.data.push(pymt.total)
                })
                tmpObjChartData.datasets.push(tmpDataset)
                arrChartsData.push(tmpObjChartData)
            })            
            this.chartsData = arrChartsData
            
           i = -1
           var tmpObjChartData = new Object()
           tmpObjChartData.labels = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
           tmpObjChartData.datasets = new Array()
           //var v = this.$store.getters[this.fundraiserid + 'FundraiserPaymentsGroupedByYearMonth'].yearly
           var v = this.fundraiserPaymentsGroupedByYearMonth.yearly
           v.forEach(function(y) {
                i++
                var tmpDataset  = new Object()     
                tmpDataset.data = new Array()          
                var titleyear = y.year 
                tmpDataset.label = titleyear
                tmpDataset.backgroundColor = chartcolors[i]
                tmpDataset.fill=false
                var monthCounter =1
                y.payments.forEach(function(pymt){
                    var mdiff = parseInt(pymt.month) - monthCounter 
                    //console.log('mdiff: ' + mdiff + '  parseInt(pymt.month) ' +  parseInt(pymt.month) + ' - monthCounter ' + monthCounter)
                    while (mdiff>0){
                        //tmpDataset.data.push(0)   
                        mdiff--
                        monthCounter++
                        tmpDataset.data.push(0)
                    }
                    tmpDataset.data.push(pymt.total)
                    monthCounter++
                })
                tmpObjChartData.datasets.push(tmpDataset)
            })      
            //console.log('tmpObjChartData',tmpObjChartData)      
            this.lineChartData =  tmpObjChartData
            
          

            

        }
        
             
    }
  }
</script>

<style>
#postFieldList .v-subheader{
    width:110px;
    padding-left: 0px;
    background-color: ghostwhite;
    margin-right: 8px;
}

#postComments .v-card{
    background-color:blue;
}
#fieldContainer .v-card__text{
    padding:5px;
}
.fieldlabel, .fieldlabel .v-card{
    background-color: ghostwhite;
    text-align: left;
}

.convo-card{
  border-radius:15px;
 
}


.chat-card{
  border-radius:15px;
  padding-left:10px;
  margin-right:10px;  
  
}

.chat-card-me{
  border-radius:15px;
  padding-left:10px;
  margin-right:10px;  
  
}

.chat-card-date{
    text-align: right;
    margin-right:15px;
    color:dimgrey;
}
</style>

<style scoped>
.hello {
  width: 100%;
  height: 100%;
 
}
</style>